export const getProductImageUrl = product => {
	if (!product) {
		return null;
	}
	return !product.imageUrl ? 'https://s3-ap-southeast-2.amazonaws.com/minotaur-systems/images/no_product_image.jpg' : product.imageUrl;
};
